export default __webpack_public_path__ + "static/media/Inter-UI-Regular.c16da073.woff2";